var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tw-flex tw-items-center",class:{
      'tw-opacity-50': _vm.status === _vm.StatusType.INCOMPLETE,
    }},[(_vm.status === _vm.StatusType.COMPLETED)?_c('Icon',{staticClass:"tw-text-green-400",attrs:{"icon":"check-square"}}):_c('Icon',{attrs:{"icon":"square"}}),_c('p',{staticClass:"tw-m-0 tw-pl-2"},[_vm._v(_vm._s(_vm.label))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }